import React from "react";
import { useNavigate } from "react-router-dom";
import { Quote, Anchor } from "lucide-react";
import { testimonials } from "../../mock";

export const Testimonials = () => (
  <section id="community" className="border-t border-stone-200/80 bg-white py-20 sm:py-28" data-testid="landing-testimonials">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="text-xs font-bold uppercase tracking-widest text-[#FF4500]">Proof from the Fleet</span>
        <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-slate-950 sm:text-5xl">Trusted by India's maritime community</h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg" data-testid="hero-stat-text">
          9,000+ Indian seafarers, 400+ shipping companies &amp; 110+ DG Shipping-approved institutes and counting.
        </p>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {testimonials.map((t) => (
          <article key={t.id} className="flex flex-col justify-between rounded-3xl border border-stone-200/90 bg-stone-50/60 p-8 transition-shadow hover:bg-white hover:shadow-lg" data-testid={`testimonial-${t.id}`}>
            <div>
              <Quote className="h-8 w-8 text-[#FF4500]/40" />
              <p className="mt-6 text-base font-medium leading-relaxed text-slate-800">"{t.quote}"</p>
            </div>
            <div className="mt-8 flex items-center gap-3.5 border-t border-stone-200/80 pt-5">
              <span className="font-heading flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-orange-100 text-sm font-bold text-[#c2410c]">{t.name.charAt(0)}</span>
              <div>
                <h3 className="font-heading text-sm font-bold text-slate-950">{t.name}</h3>
                <p className="text-xs text-slate-500">{t.role}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export const CtaBanner = () => {
  const navigate = useNavigate();
  return (
    <section id="join" className="bg-white py-12 sm:py-20" data-testid="landing-cta">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[#FF4500] px-6 py-16 text-center text-white shadow-xl shadow-orange-600/20 sm:px-14 sm:py-20">
          <Anchor className="pointer-events-none absolute -right-10 -top-10 h-64 w-64 text-white/10 sm:h-80 sm:w-80" strokeWidth={1.5} />
          <div className="relative z-10 mx-auto max-w-2xl">
            <span className="inline-block rounded-full bg-white/15 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-white">100% Direct Maritime Network</span>
            <h2 className="font-heading mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">No Agents. No Excuses. Join Real Ships.</h2>
            <p className="mt-4 text-base text-orange-50 sm:text-lg">Sign up free, follow your favourite fleets, and never miss the next sign-on.</p>
            <button onClick={() => navigate("/signup")} data-testid="cta-create-account"
              className="mt-8 inline-flex w-full items-center justify-center rounded-full bg-white px-8 py-4 text-sm font-bold text-[#FF4500] shadow-lg transition-colors hover:bg-orange-50 sm:w-auto">
              Create your free account
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
